import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { ref, computed, watch } from 'vue'
import { orgInfoAdd, orgInfoUpdate, orgInfoDetail } from '@/api'
import { CODE_ENUM } from '@/common'
import { ElMessage } from 'element-plus'
import { queryOrgTreeList } from '@/api'
import { isEmpty } from 'lodash'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'org-form',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t



const mapRef = ref()
const formRef = ref()

const formData: any = ref({
  name: '',
  describe: '',
  sort: undefined,
  parentOrgId: '',
})

const title = computed(() => {
  return props.data?.id ? t('ORG.editTitle') : t('ORG.newTitle')
})

const detailLoading = ref(false)
watch(
  () => props.visible,
  async () => {
    if (props.visible) {
      // detailLoading.value = true
      // Promise.all([queryDetail(), queryOrgList()]).finally(() => {
      //   detailLoading.value = false
      // })
      queryOrgList()
      initData()
    }
  }
)

const initData = () => {
  if (isEmpty(props.data)) {
    return
  }
  console.log(props.data, '===')
  const { name, describe, sort, parentOrgId } = props.data
  formData.value = {
    name,
    parentOrgId,
    sort,
    describe,
  }
}

const rules: any = {
  name: [{ required: true, message: t('ORG.enter') }],
  describe: [{ required: true, message: t('ORG.enter') }],
  sort: [{ required: true, message: t('ORG.enterMsg') }],
  parentOrgId: [{ required: true, message: t('ORG.select') }],
}

const submit = () => {
  formRef.value.validate((valid: boolean) => {
    if (valid) {
      handleAPI()
    }
  })
}

const loading = ref(false)
const handleAPI = async () => {
  loading.value = true
  // const key = props.data?.name ? 'name' : 'describe'

  const fn = props.data?.id ? orgInfoUpdate : orgInfoAdd
  const res: any = await fn({
    ...formData.value,
    id: props.data?.id,
  }).finally(() => {
    loading.value = false
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    $emit('on-success')
    handleClose()
  }
}

// const queryDetail = async () => {
//   const { value } = props.data
//   if (!value) {
//     return
//   }
//   const res: any = await orgInfoDetail({
//     orgId: value,
//   })
//   if (res?.code === CODE_ENUM.SUCCESS) {
//     const { id, name, parentOrgId, sort, describe } = res.data
//     formData.value = {
//       name,
//       parentOrgId,
//       sort,
//       describe,
//     }
//   }
// }

const orgList: any = ref([])
const queryOrgList = async () => {
  const res: any = await queryOrgTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    console.log(res.data)
    orgList.value = deepFormat([res.data])
  }
}

const deepFormat = (list: any, level = 0) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, name, ...p } = item
    return {
      ...p,
      value: id,
      label: name,
      children: deepFormat(children, level + 1),
      level: level + 1,
      disabled: level >= 5,
    }
  })
}
const handleClose = () => {
  $emit('update:visible', false)
  formRef.value?.resetFields?.()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    "destroy-on-close": "",
    title: _unref(title),
    width: "520",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        plain: "",
        onClick: handleClose
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ORG.btnCancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit,
        loading: loading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('ORG.btnYes')), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: rules,
        class: "form ws_common_form",
        "label-width": 90
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('ORG.name'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                clearable: "",
                maxlength: "30"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('ORG.topOrg'),
            prop: "parentOrgId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tree_select, {
                disabled: !!props.data.value,
                filterable: "",
                "check-strictly": "",
                "default-expand-all": "",
                modelValue: formData.value.parentOrgId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.parentOrgId) = $event)),
                data: orgList.value,
                "render-after-expand": true,
                class: "ws_select_form"
              }, null, 8, ["disabled", "modelValue", "data"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('ORG.desc'),
            prop: "describe"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.describe,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.describe) = $event)),
                clearable: "",
                maxlength: "35"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('ORG.sort'),
            prop: "sort"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                class: "ws_common_input_number",
                modelValue: formData.value.sort,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.sort) = $event)),
                clearable: "",
                min: 0,
                max: 999,
                precision: 0,
                controls: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])), [
        [_directive_loading, detailLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})